module.exports = __webpack_public_path__ + "media/images/procedure_managements/examples/actors_image-ea05ea541601938786e4de0b568a3f87.jpg";